import cookies_settings from "@views/common/CookiesSettingsModal/cookies_settings";

export default {
  name: 'cookies-notice',
  mixins: [cookies_settings],
  data() {
    return {
      b_show: false,
      is_dev: process.env.NODE_ENV !== 'production',
      d_expiry: null,
    }
  },
  methods: {
    close() {
      this.acceptAllCookies();
      this.b_show = false
      this.$emit('close-notice')
    }
  },
  created() {
    this.b_show = !window.APP_CONFIG.COOKIE_POPUP && !this.$store.getters['cookies/isConsentApproved'];
  }
}
